import { useCallback, useEffect, useRef, useState } from "react";

import configs from "../../configs";

const useRecaptcha = () => {
  const [gRecaptcha, setGRecaptcha] = useState(window.grecaptcha);
  const [isRecaptchaReady, setIsRecaptchaReady] = useState<boolean>(false);

  const containerId = useRef("g-recaptcha");

  useEffect(() => {
    if (gRecaptcha) {
      setIsRecaptchaReady(true);
      return;
    }
    console.log("Init Recaptcha");
    const script = document.createElement("script");

    script.id = "gRecaptcha";
    script.src = `https://www.google.com/recaptcha/api.js`;
    script.async = true;

    script.onload = () => {
      setGRecaptcha(window.grecaptcha);
      window.grecaptcha.ready(() => {
        setIsRecaptchaReady(true);
      });
    };
    document.head.appendChild(script);
    // eslint-disable-next-line
  }, []);

  const gRecaptchaToken = useCallback(() => {
    const gRecaptchaContainer = document.createElement("div");
    gRecaptchaContainer.id = containerId.current;
    gRecaptchaContainer.setAttribute(
      "data-sitekey",
      configs.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY
    );
    gRecaptchaContainer.setAttribute("data-size", "invisible");
    gRecaptchaContainer.style.display = "none";
    document.body.append(gRecaptchaContainer);

    return new Promise<string>((resolve) => {
      const recaptcha = window.grecaptcha;
      recaptcha.render(containerId.current, {
        callback: (token) => resolve(token),
      });
      recaptcha.execute();
    })
      .catch((error) => {
        throw new Error(error);
      })
      .finally(() => {
        gRecaptchaContainer.remove();
      });
  }, []);

  return { gRecaptcha, gRecaptchaToken, isRecaptchaReady };
};

export default useRecaptcha;
